module.exports = __webpack_public_path__ + "static/media/tv.2bef4b9f.svg";